import React from 'react';
import util from "../../util/tools";
import { checkExpired } from "../../../common/util";
import commonTools from "../../../common/util/util";
import { goRoute } from '../common/js'
import { Link } from 'react-router-dom'
import LoadMore from '../common/LoadMore'
import './index.css';
import {isTest} from "../../../config";
import Header from "../common/Header";
import Activity from '../common/activity'
import ActivityPopup from '../common/ActivityPopup'

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            shubaoPage:1,
            quanbenPage:1,
            page: 1,
            curTitle: "历史",
            recommendData: [],
            data: [],
            isLoad: false,
            showDialog: false,
            del: 1,
            delTip: "是否清空历史记录，删除后无法恢复",
            delItem: '',
            czhdStart: false,//充值活动是否开始 默认关闭
            czhdYear: false,//春节充值活动
            doubleOneStart: false, //双十一充值活动是否开始 默认关闭
            yuandanStart: false, //元旦充值活动是否开始 默认关闭
            curType: 1,//类型 默认1:阅读记录 2:书包专区
            sbData: [],
            qbData:[],
            moreLoading:false,
            activeData: {  // 活动数据
                img_url: "",
                link_url: "",
                only_home: 1
            },
            showPopup: false,
            popupId: null,
            activityUrl: '',
            activityId: ''
        };
        this.ydjlFun = this.ydjlFun.bind(this);
        this.checkFun = this.checkFun.bind(this);
        this.sbzqFun = this.sbzqFun.bind(this);
        this.childData = this.childData.bind(this);
        this.delData = this.delData.bind(this);
    }
    getActiveInfo(){
        util.ajax({
            url: "/zh/additional/acitve",
            data:{
                only_home: 0
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    console.log('活动数据',json);
                    this.setState({activeData: json})
                }
            }
        });
    }

    componentDidMount() {
        this.getActiveInfo();
        document.title = this.state.curTitle;

        let minTime = new Date("2018/12/22 00:00:00").getTime();
        let maxTime = new Date("2019/01/07 00:00:00").getTime();
        let curTime = new Date().getTime();
        if ((curTime >= minTime && curTime <= maxTime) || !!commonTools.searchPar().czhdStart) {
            this.setState({
                czhdStart: true
            });
        }
        let minYearTime = new Date("2019/02/01 00:00:00").getTime();
        let maxYearTime = new Date("2019/02/11 00:00:00").getTime();
        if ((curTime >= minYearTime && curTime < maxYearTime) || !!commonTools.searchPar().czhdYear) {
            this.setState({
                czhdYear: true
            });
        }
        let minTime4 = new Date("2019/11/11 00:00:00").getTime();
        let maxTime4 = new Date("2019/11/14 00:00:00").getTime();
        if((curTime >= minTime4 && curTime <= maxTime4) || !!commonTools.searchPar().doubleOneStart){
            this.setState({
                doubleOneStart: true
            });
        }
        let minTime5 = new Date("2019/12/31 19:00:00").getTime();
        let maxTime5 = new Date("2020/01/4 23:59:00").getTime();
        if((curTime >= minTime5 && curTime <= maxTime5) || !!commonTools.searchPar().yuandanStart){
            this.setState({
                yuandanStart: true
            });
        }
        this.checkFun(commonTools.searchPar().curType)
        this.checkPopup()
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.touchEnd===true && this.props.touchEnd===false && (this.state.curType === 2 || this.state.curType === 3)){//书包专区
            if(this.state.curType === 2){
                this.setMoreLoading(true)
                this.addSbzqFun()
            }else{
                this.setMoreLoading(true)
                this.addQbzqFun()
            }
        }
    }

    setMoreLoading = (moreLoading) => {
        this.setState({
            moreLoading,
        })
    }

    checkFun(curType) {
        this.setState({
            curType: curType || 1,
            shubaoPage:1,
            quanbenPage:1,
        }, () => {
            switch (this.state.curType + "") {
                case "1":
                    this.ydjlFun();
                    break;
                case "2":
                    this.sbzqFun();
                    break;
                case "3":
                    this.qbzqFun();
                    break;
            }
        })
    }

    addSbzqFun() {
        util.ajax({
            url: "/zh/bookpack/bookPackLists",
            isUser: true,
            isWechatId: true,
            data:{
                page:this.state.shubaoPage + 1,
                num:20,
            },
            callback: res => {
                this.setMoreLoading(false)
                if (res.result.status.code == 0) {
                    let json = res.result.data
                    if(json.length > 0){
                        this.setState({
                            shubaoPage:this.state.shubaoPage + 1,
                            sbData: [...this.state.sbData,...json]
                        })
                    }
                }
            }
        });
    }

    addQbzqFun() {
        util.ajax({
            url: "/zh/allbookbuy/getBuyBook",
            isUser: true,
            isWechatId: true,
            data:{
                page:this.state.quanbenPage + 1,
                num:20,
            },
            callback: res => {
                this.setMoreLoading(false)
                if (res.result.status.code == 0) {
                    let json = res.result.data
                    if(json.length > 0){
                        this.setState({
                            quanbenPage:this.state.quanbenPage + 1,
                            qbData: [...this.state.qbData,...json],
                        })
                    }
                }
            }
        });
    }

    sbzqFun() {
        if (!this.state.tj && false) {
            this.setState({
                tj: true
            }, () => {
                util.ajax({
                    url: "/zh/drawprize/recordViewNum",
                    isUser: true,
                    isWechatId: true,
                    data: {
                        type: 2,
                    }
                });
            });
        }
        util.ajax({
            url: "/zh/bookpack/bookPackLists",
            isUser: true,
            isWechatId: true,
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data
                    this.setState({
                        sbData: json
                    })
                }
            }
        });
    }

    qbzqFun() {//全本购专区
        util.ajax({
            url: "/zh/allbookbuy/getBuyBook",
            isUser: true,
            isWechatId: true,
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data
                    this.setState({
                        qbData: json
                    })
                }
            }
        });
    }

    ydjlFun() {
        this.rmdData()
        this.result()
    }

    rmdData() {
        util.ajax({
            url: "/zh/book/historyRecommend",
            isUser: true,
            isWechatId: true,
            data: {
                're_cid': 145,
                'num': 2,
                'page': 1,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data
                    this.setState({
                        recommendData: json
                    })
                }
            }
        });
    }

    result() {
        let num = 20;
        util.ajax({
            url: "/zh/user/getUserReadHistoryv1",
            isUser: true,
            data: {
                'num': num,
                'page': this.state.page,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempData = {
                        page: parseInt(this.state.page) + 1,
                        isLoad: false,
                        data: this.state.data.concat(json)
                    }
                    if (json.length >= num) {
                        // 还未到最后一页
                        // num传20的时候，后台查询阅文20条，自己的后台20条数据拼接起。相当于没有分页！！！
                        tempData.isLoad = true;
                    }

                    this.setState(tempData)
                }
            }
        });
    }

    delete(opt) {
        // 默认清空所有
        let tempData = {
            url: "/zh/user/clearAllReadHistoryv1",
            data: {},
            endData: []
        };
        if (!!opt) {
            // 删除单个
            tempData.url = "/zh/user/delReadHistoryv1"
            tempData.data = {
                'book_id': opt.book_id,
                '__flush_cache': 1
            };
            tempData.endData = this.state.data.filter((item, index) => {
                return item.book_id != opt.book_id
            })
        }
        util.ajax({
            url: tempData.url,
            isUser: true,
            data: tempData.data,
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        data: tempData.endData,
                    })
                }
            }
        });
    }

    close(e) {
        if (e.target.getAttribute('class') == 'his_modal' || e.target.getAttribute('class') == 'close') {
            this.setState({
                showDialog: false
            })
        }
    }

    isSure(e, item) {
        // 默认删除单个
        let tempData = {
            showDialog: true,
            delTip: "是否删除该条记录，删除后无法恢复",
            del: 1,
            delItem: item
        };
        if (!item) {
            if (this.state.data.length > 0) {
                tempData.del = 2;
                tempData.delTip = "是否清空历史记录，删除后无法恢复";
            } else {
                return false;
            }
        }
        this.setState(tempData);
    }

    isDelete() {
        this.setState({
            showDialog: false
        }, () => {
            let del = this.state.del, item = null;
            if (del == 1) {
                item = this.state.delItem;
            }
            this.delete(item);
        })
    }

    childData(bookpack_id) {
        let sbData = this.state.sbData;
        let tindex = 0;
        sbData.forEach(function (item, index) {
            if (item.bookpack_id == bookpack_id) {
                item.isActive = !item.isActive;
                tindex = index;
            }
        })
        if (!sbData[tindex].data) {
            // 请求数据获取书包书籍
            sbData[tindex].data = [{loading:true}];
            this.setState({
                sbData: sbData
            })
            util.ajax({
                url: "/zh/bookpack/getBuyBook",
                isUser: true,
                isWechatId: true,
                data: {
                    'bookpack_id': bookpack_id,
                },
                callback: res => {
                    if (res.result.status.code == 0) {
                        let json = res.result.data
                        sbData[tindex].data = json;
                        this.setState({
                            sbData: sbData
                        })
                    }
                }
            });
        } else {
            this.setState({
                sbData: sbData
            })
        }
    }

    delData(bookpack_id) {
        util.ajax({
            url: "/zh/bookpack/del",
            isUser: true,
            isWechatId: true,
            data: {
                'bookpack_id': bookpack_id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.checkFun(2)
                }
            }
        });
    }

    readBook(item) {
        this.props.history.push(`/readpage/${item.book_id}/${item.content_id}`)
    }
    
    // 判断是否有活动弹窗
    checkPopup() {
        const date = new Date()
        const fullYear = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        const fullDate = `${fullYear}-${month+1}-${day}`
        const oldDate = localStorage.popupDate2
        util.ajax({
            url: '/zh/activity/activitypopup',
            data:{
                popup_id: 2
            },
            callback: res => {
                // console.log(res)
                if (res.result.status.code == 0 && res.result.data.length) {
                    const data = res.result.data[0]
                    this.setState({
                        popupId: data.temp_id,
                        activityUrl: data.activity_url,
                        activityId: data.id
                    })
                    if (!oldDate) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate2 = fullDate
                    } else if (oldDate && fullDate != oldDate ) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate2 = fullDate
                    } else {
                        this.setState({
                            showPopup: false
                        })
                    }
                }
            }
        })
    }

    // 关闭弹窗
    closePopup = () => {
        this.setState({
            showPopup: false
        })
    }

    render() {
        return (
            <div className='history'>
                <Header />
                {
                    !!this.state.yuandanStart &&
                    <Link to='/activeFirstDayForYear?from=3'><img style={{display:'block',width:'100%'}} src={require("../../../common/images/yuandanmin.jpg")} /></Link>
                }
                {/*活动*/}
                {
                    this.state.activeData.img_url && this.state.activeData.only_home === 0 &&
                    <Link to={this.state.activeData.link_url + '?from=3'}><img style={{display:'block',width:'100%'}} src={this.state.activeData.img_url} /></Link>
                }
                <div className='header'>
                    {
                        <div className='menus clearfix'>
                            {/*<span className={`menu`}>阅读记录</span>*/}
                            <span className={`menu ${this.state.curType == 1 ? "active" : ""}`} onClick={() => this.checkFun(1)}>阅读记录</span>
                            {/*<span className={`menu ${this.state.curType == 2 ? "active" : ""}`} onClick={() => this.checkFun(2)}>书包专区</span>*/}
                            {/*{*/}
                                {/*<span className={`menu ${this.state.curType == 3 ? "active" : ""}`} onClick={() => this.checkFun(3)}>全本购买</span>*/}
                            {/*}*/}
                        </div>
                    }
                    {/*<Link to='/' className='header_font'>首页</Link>*/}
                    {/*{*/}
                        {/*this.state.curType == 1 &&*/}
                        {/*<span className='header_line'></span>*/}
                    {/*}*/}
                    {
                        this.state.curType == 1 &&
                        <span className='header_clear' onClick={(e) => this.isSure(e)}>清空</span>
                    }
                </div>
                {
                    this.state.curType == 1 &&
                    <div className='books'>
                        {/* 公共活动 */}
                        <Activity location="recentlyread" notStyle={false}/>
                        {
                            !!this.state.czhdStart &&
                            <Link to='/payactivity'><img className="czhd" src={require("../../../common/images/czhdentry.jpg")} /></Link>
                        }
                        {
                            !!this.state.czhdYear &&
                            <Link to='/payyear'><img className="czhd" src={require("../../../common/images/yearentry.jpg")} /></Link>
                        }
                        {
                            !!this.state.doubleOneStart &&
                            <Link to='/dubleonecharge'><img className="czhd" src={require("../../../common/images/dubleBg.jpg")} /></Link>
                        }

                        {!!this.state.recommendData && this.state.recommendData.length > 0 &&
                            <div className={`books_recommend`}>
                                {this.state.recommendData.map((item, index) => (
                                    <div className='books_recommend_single' key={`rd_${index}`} onClick={() => goRoute(this.props, item.book_id, 0)}>
                                        <div className='books_recommend_single_l'>
                                            <img className='books_recommend_single_l_pic' src={item.cover_url} />
                                            <div className='books_recommend_single_l_icon'>推荐</div>
                                        </div>
                                        <div className='books_recommend_single_r'>
                                            <span className='books_recommend_single_r_name text-overflow'>{item.book_title}</span>
                                            <span className='books_recommend_single_r_type text-overflow'>{item.category_info.category_1.short_name}</span>
                                            <span className='books_recommend_single_r_intro text-overflow2'>{item.book_intro_1}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>}
                        <div>
                            {!!this.state.data && this.state.data.length > 0 &&
                                this.state.data.map((item, index) => (
                                    <div className='books_single' key={`h${index}`} >
                                        <h3 className='books_single_name text-overflow'>{item.book_title}</h3>
                                        <div className='books_single_mes'>
                                            <span className='books_single_mes_name' onClick={() => goRoute(this.props, item.book_id, item.content_id, true)}>{item.author_name}</span>
                                            <span className='books_single_had' onClick={() => goRoute(this.props, item.book_id, item.content_id, true)}>已读{item.title}</span>
                                            <span className='books_single_all' onClick={() => goRoute(this.props, item.book_id, item.content_id, true)}>共{item.chapter_count || 0}章</span>
                                            <a className='books_single_del' onClick={(e) => this.isSure(e, item)}>删除</a>
                                        </div>
                                    </div>
                                ))}
                            {/*{this.state.isLoad && <LoadMore loadMoreData={() => this.result()} />}*/}
                            {/*历史记录没有分页*/}
                        </div>
                    </div>
                }
                {
                    this.state.curType == 2 &&
                    <div className="sbzqBox">
                        <div className="title">书包专区</div>
                        <div className="list1">
                            {
                                this.state.sbData.map((item, index) => (
                                    <div className="item" key={`sb_${index}`}>
                                        <div className={`title2 ${!!item.isActive ? "active" : ""}`} onClick={() => this.childData(item.bookpack_id,"sbData")}>
                                            <div className="name">{item.bookpack_name}</div>
                                            <div className="time">{item.createtime} 购买</div>
                                        </div>
                                        <div className="books sbzq">
                                            {!!item.data && item.data.length > 0 &&
                                            item.data.map((item1, index1) => {
                                                return  (
                                                    <div className='books_single' key={`h${index1}`} >
                                                        <h3 className='books_single_name text-overflow'>{item1.book_title}</h3>
                                                        {
                                                            item1.loading ?
                                                                <div className='books_single_mes'>
                                                                    <div className='loading'>加载中...</div>
                                                                </div> :
                                                                <div className='books_single_mes'>
                                                                    <span className='books_single_mes_name' onClick={() => goRoute(this.props, item1.book_id, item1.content_id, true)}>{item1.author_name}</span>
                                                                    <span className='books_single_had' onClick={() => goRoute(this.props, item1.book_id, item1.content_id, true)}>已读{item1.title}</span>
                                                                    <span className='books_single_all' onClick={() => goRoute(this.props, item1.book_id, item1.content_id, true)}>共{item1.chapter_count || 0}章</span>
                                                                </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            this.state.moreLoading ?
                                <p style={{textAlign:"center",color:"#666"}}>加载中...</p> : null
                        }
                    </div>
                }
                {
                    this.state.curType == 3 &&
                    <div className="sbzqBox">
                        <div className="title">全本购</div>
                        <div className="list1">
                            {
                                this.state.qbData.map((item, index) => (
                                    <div className="item" key={`sb_${index}`} onClick={()=>this.readBook(item)}>
                                        <div className={`title2 ${!!item.isActive ? "active" : ""}`} style={{height:"1.26rem"}}>
                                            <div className="name" style={{fontSize:"0.28rem",marginBottom:"0.1rem"}}>{item.book_title}<span className="time" style={{float:"right"}}>{item.createtime} 购买</span></div>
                                            <div className="time">
                                                <span className="hidden-no-wrap" style={{position:"absolute",left:"0.3rem",maxWidth:"2.60rem"}}>{item.author_name}</span>
                                                <span className="hidden-no-wrap" style={{position:"absolute",right:"0.3rem",maxWidth:"3.50rem"}}>已读{item.title},共{item.chapter_count}章</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        {
                            this.state.moreLoading ?
                                <p style={{textAlign:"center",color:"#666"}}>加载中...</p> : null
                        }
                    </div>
                }
                {this.state.showDialog && <div className='his_modal' onClick={(e) => this.close(e)}>
                    <div className='his_dialog'>
                        <p className='center'>{this.state.delTip}</p>
                        <div className='btm'>
                            <a className='close' onClick={(e) => this.close(e)}>取消</a>
                            <a className='sure' onClick={() => this.isDelete()}>确定</a>
                        </div>
                    </div>
                </div>}
                {
                    this.state.showPopup &&
                    <ActivityPopup
                        popupId={this.state.popupId} activityUrl={this.state.activityUrl}
                        activityId={this.state.activityId} closePopup={this.closePopup}>
                    </ActivityPopup>
                }
            </div>
        );
    }
}